var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("arrow_back")])],1),_c('v-toolbar-title',{staticClass:"raidTitle",on:{"click":_vm.toRaidDashboard}},[_vm._v(_vm._s(_vm.raidName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }